import { TValidateTokenRes } from "@sharedTypes/res.type";
import axios from "axios";

export async function ValidateToken() {
  const apiUrl = "/auth/ValidateToken";

  const data: TValidateTokenRes = await axios
    .post(apiUrl)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
